import { useCallback, useContext } from "react";

import { TenantContext } from "@nens/ranalib";
import { useLocalStorage } from "@nens/react/hooks";

import { useInstancePermissions } from "@/queries/query-instance-permissions";

const DROPSWISE_TENANT = "pcp-wise-demo";

export function useSidebar() {
  const [isOpen, setIsOpen] = useLocalStorage("rana.sidebar-open", false);

  const openSidebar = useCallback(() => setIsOpen(true), [setIsOpen]);
  const closeSidebar = useCallback(() => setIsOpen(false), [setIsOpen]);

  const authInfo = useContext(TenantContext);

  const { tenant } = authInfo;

  const tenantBaseUrl = `/${tenant}`;
  const isDropsWise = tenant === DROPSWISE_TENANT;

  const { canListTenant, canManageUser } = useInstancePermissions();
  const canOpenAdminPanel = canListTenant || canManageUser;

  return { isOpen, openSidebar, closeSidebar, tenantBaseUrl, canOpenAdminPanel, isDropsWise };
}
